export const ALL_FILES = 'ALL_FILES'
export const ALL_FILES_SUCCESS = 'ALL_FILES_SUCCESS'
export const ALL_FILES_FAILURE = 'ALL_FILES_FAILURE'

export const ERROR_MSG = 'ERROR_MSG'
export const SUCCESS_MSG = 'SUCCESS_MSG'

export const SIGNED_URL_FOR_UPLOAD = 'SIGNED_URL_FOR_UPLOAD'
export const SIGNED_URL_FOR_UPLOAD_SUCCESS = 'SIGNED_URL_FOR_UPLOAD_SUCCESS'
export const SIGNED_URL_FOR_UPLOAD_FAILURE = 'SIGNED_URL_FOR_UPLOAD_FAILURE'

export const SIGNED_URL_FOR_DOWNLOAD = 'SIGNED_URL_FOR_DOWNLOAD'
export const SIGNED_URL_FOR_DOWNLOAD_SUCCESS = 'SIGNED_URL_FOR_DOWNLOAD_SUCCESS'
export const SIGNED_URL_FOR_DOWNLOAD_FAILURE = 'SIGNED_URL_FOR_DOWNLOAD_FAILURE'

export const FILES_UPLOAD = 'FILES_UPLOAD'
export const FILES_UPLOAD_SUCCESS = 'FILES_UPLOAD_SUCCESS'

export const FILES_DOWNLOAD = 'FILES_DOWNLOAD'
export const FILES_DOWNLOAD_SUCCESS = 'FILES_DOWNLOAD_SUCCESS'

export const GET_USER_DETAILS = 'GET_USER_DETAILS'
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS'
export const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE'

export const GET_USER_TASK_DECISION_FLAG = 'GET_TASK_DECISION_FLAG'
export const GET_USER_TASK_DECISION_FLAG_SUCCESS = 'GET_TASK_DECISION_FLAG_SUCCESS'

export const DROPZONE_CONFIG = 'DROPZONE_CONFIG'
export const DROPZONE_CONFIG_SUCCESS = 'DROPZONE_CONFIG_SUCCESS'

export const DOWNLOADING = 'DOWNLOADING'
export const DOWNLOADING_SUCCESS = 'DOWNLOADING_SUCCESS'

export const NOTIFY = 'NOTIFY'
export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS'

export const META_NOTIFY = 'NOTIFY'
export const META_NOTIFY_SUCCESS = 'NOTIFY_SUCCESS'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js